const en_other_cost = {
    "": "Other Costs",
    add: "Add Other Cost",
    edit: "Edit Other Cost",

    label: {
        name: "Cost Name",
        type: "Cost Type",
        coa_debit: "Debit COA",
        coa_credit: "Credit COA",
    },

    error: {
        name: "Cost name is required.",
        type: "Cost type is required.",
        coa_debit: "Debit COA is required.",
        coa_credit: "Credit COA is required.",
        create: "Failed to create other cost.",
        delete: "Failed to delete other cost.",
        edit: "Failed to update other cost.",
    },

    success: {
        create: "Other cost created successfully.",
        delete: "Other cost deleted successfully.",
        edit: "Other cost updated successfully.",
    },
}

export default en_other_cost;